<script>
	import { cn } from "./cn.js";
	import { theme, toggleTheme } from "./theme.js";
	let className = "";
	export { className as class };
</script>

<button
	type="button"
	on:click|stopPropagation={toggleTheme}
	aria-label="테마 전환"
	title={$theme === "dark" ? "라이트 모드로" : "다크 모드로"}
	class={cn(
		"tw-inline-flex tw-h-9 tw-w-9 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-md tw-text-muted-foreground tw-transition-colors hover:tw-bg-muted hover:tw-text-foreground",
		className,
	)}
>
	{#if $theme === "dark"}
		<!-- sun -->
		<svg class="tw-h-[18px] tw-w-[18px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
			<circle cx="12" cy="12" r="4" />
			<path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
		</svg>
	{:else}
		<!-- moon -->
		<svg class="tw-h-[18px] tw-w-[18px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
			<path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" />
		</svg>
	{/if}
</button>
